<script setup lang="ts">
  defineProps<{ direction: 'left' | 'right' }>()
</script>

<template>
  <svg
    :class="`w-full h-2 ${direction === 'left' && 'rounded-l-full'} ${direction === 'right' && 'rounded-r-full'}`"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- 底部灰色轨道背景 -->
    <rect x="0" y="0" width="100%" height="8" fill="#9A9EA6" rx="1" />

    <!--
      重复的小箭头，方向由 direction 决定
      用 pattern 铺满整个区域
    -->
    <defs>
      <pattern id="arrows-left" x="0" y="0" width="10" height="8" patternUnits="userSpaceOnUse">
        <!-- 向左的箭头 « -->
        <polyline
          points="7,1 3,4 7,7"
          fill="none"
          stroke="#E8EAED"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </pattern>
      <pattern id="arrows-right" x="0" y="0" width="10" height="8" patternUnits="userSpaceOnUse">
        <!-- 向右的箭头 » -->
        <polyline
          points="3,1 7,4 3,7"
          fill="none"
          stroke="#E8EAED"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </pattern>
    </defs>

    <rect x="0" y="0" width="100%" height="8" :fill="`url(#arrows-${direction})`" />
  </svg>
</template>
